import { Switch } from '@mui/material';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectProdDataStatus, setProdDataStatus } from 'features/cris/cris.slice';

export const ProdDataSwitch: React.FC = () => {
    const dispatch = useDispatch();
    const prodDataStatus = useSelector(selectProdDataStatus);

    const handleToggle = () => {
        // Toggle the prodDataStatus
        dispatch(setProdDataStatus(!prodDataStatus));
    };

    return (
        <div>
            <label>Prod Data:</label>
            <Switch
                checked={prodDataStatus}
                onChange={handleToggle}
                name='ProdDataToggle'
                inputProps={{ 'aria-label': 'toggle show production data' }}
            />
        </div>
    );
};
